let collection_departamentos = [
    { "cod": "DEP0001", "nombre": "BENI", "id": 2359 },
    { "cod": "DEP0002", "nombre": "COCHABAMBA", "id": 2360 },
    { "cod": "DEP0004", "nombre": "LA PAZ", "id": 2362 },
    { "cod": "DEP0005", "nombre": "ORURO", "id": 2363 },
    { "cod": "DEP0006", "nombre": "PANDO", "id": 2364 },
    { "cod": "DEP0007", "nombre": "POTOSI", "id": 2365 },
    { "cod": "DEP0008", "nombre": "SANTA CRUZ", "id": 2366 },
    { "cod": "DEP0009", "nombre": "CHUQUISACA", "id": 2367 },
    { "cod": "DEP0010", "nombre": "TARIJA", "id": 2368 },
    { "cod": "DEP0011", "nombre": "NO APLICA", "id": 3468 }
]

let collection_ciudades = [
    { "cod": "CIU0003", "nombre": "ACASIO", "id": 2365 },
    { "cod": "CIU0005", "nombre": "ACHACACHI", "id": 2362 },
    { "cod": "CIU0007", "nombre": "ACHOCALLA", "id": 2362 },
    { "cod": "CIU0013", "nombre": "AIQUILE", "id": 2360 },
    { "cod": "CIU0016", "nombre": "ALALAY", "id": 2360 },
    { "cod": "CIU0037", "nombre": "ANCORAIMES", "id": 2362 },
    { "cod": "CIU0043", "nombre": "ANTEQUERA", "id": 2363 },
    { "cod": "CIU0047", "nombre": "ANZALDO", "id": 2360 },
    { "cod": "CIU0050", "nombre": "APOLO", "id": 2362 },
    { "cod": "CIU0055", "nombre": "ARAMPAMPA", "id": 2365 },
    { "cod": "CIU0056", "nombre": "ARANI", "id": 2360 },
    { "cod": "CIU0059", "nombre": "ARBIETO", "id": 2360 },
    { "cod": "CIU0065", "nombre": "ARQUE", "id": 2360 },
    { "cod": "CIU0069", "nombre": "ASCENCION DE GUARAYOS", "id": 2366 },
    { "cod": "CIU0077", "nombre": "ATOCHA", "id": 2365 },
    { "cod": "CIU0079", "nombre": "AUCAPATA", "id": 2362 },
    { "cod": "CIU0084", "nombre": "AYATA", "id": 2362 },
    { "cod": "CIU0087", "nombre": "AYO AYO", "id": 2362 },
    { "cod": "CIU0091", "nombre": "AZURDUY", "id": 2367 },
    { "cod": "CIU0093", "nombre": "BATALLAS", "id": 2362 },
    { "cod": "CIU0094", "nombre": "BAURES", "id": 2359 },
    { "cod": "CIU0100", "nombre": "BELEN DE ANDAMARCA", "id": 2363 },
    { "cod": "CIU0106", "nombre": "BERMEJO", "id": 2368 },
    { "cod": "CIU0108", "nombre": "BETANZOS", "id": 2365 },
    { "cod": "CIU0109", "nombre": "BOLIVAR", "id": 2360 },
    { "cod": "CIU0115", "nombre": "BOYUIBE", "id": 2366 },
    { "cod": "CIU0118", "nombre": "BUENA VISTA", "id": 2366 },
    { "cod": "CIU0120", "nombre": "CABEZAS", "id": 2366 },
    { "cod": "CIU0127", "nombre": "CAIROMA", "id": 2362 },
    { "cod": "CIU0129", "nombre": "CAIZA D", "id": 2365 },
    { "cod": "CIU0132", "nombre": "CAJUATA", "id": 2362 },
    { "cod": "CIU0134", "nombre": "CALACOTO", "id": 2362 },
    { "cod": "CIU0138", "nombre": "CALAMARCA", "id": 2362 },
    { "cod": "CIU0154", "nombre": "CAMARGO", "id": 2367 },
    { "cod": "CIU0157", "nombre": "CAMIRI", "id": 2366 },
    { "cod": "CIU0172", "nombre": "CAPINOTA", "id": 2360 },
    { "cod": "CIU0174", "nombre": "CAQUIAVIRI", "id": 2362 },
    { "cod": "CIU0178", "nombre": "CARACOLLO", "id": 2363 },
    { "cod": "CIU0180", "nombre": "CARANAVI", "id": 2362 },
    { "cod": "CIU0182", "nombre": "CARANGAS", "id": 2363 },
    { "cod": "CIU0183", "nombre": "CARAPARI", "id": 2368 },
    { "cod": "CIU0189", "nombre": "CARIPUYO", "id": 2365 },
    { "cod": "CIU0200", "nombre": "CATACORA", "id": 2362 },
    { "cod": "CIU0213", "nombre": "CHACARILLA", "id": 2362 },
    { "cod": "CIU0227", "nombre": "CHALLAPATA", "id": 2363 },
    { "cod": "CIU0239", "nombre": "CHAQUI", "id": 2365 },
    { "cod": "CIU0241", "nombre": "CHARAGUA", "id": 2366 },
    { "cod": "CIU0243", "nombre": "CHARAÑA", "id": 2362 },
    { "cod": "CIU0246", "nombre": "CHARAZANI", "id": 2362 },
    { "cod": "CIU0254", "nombre": "CHAYANTA", "id": 2365 },
    { "cod": "CIU0269", "nombre": "CHIMORE", "id": 2360 },
    { "cod": "CIU0276", "nombre": "CHIPAYA", "id": 2363 },
    { "cod": "CIU0292", "nombre": "CHOQUECOTA", "id": 2363 },
    { "cod": "CIU0300", "nombre": "CHUA COCANI", "id": 2362 },
    { "cod": "CIU0307", "nombre": "CHULUMANI", "id": 2362 },
    { "cod": "CIU0308", "nombre": "CHUMA", "id": 2362 },
    { "cod": "CIU0314", "nombre": "CHUQUIUTA", "id": 2365 },
    { "cod": "CIU0321", "nombre": "CLIZA", "id": 2360 },
    { "cod": "CIU0324", "nombre": "COBIJA", "id": 2364 },
    { "cod": "CIU0326", "nombre": "COCAPATA", "id": 2360 },
    { "cod": "CIU0327", "nombre": "COCHABAMBA", "id": 2360 },
    { "cod": "CIU0331", "nombre": "COIPASA", "id": 2363 },
    { "cod": "CIU0333", "nombre": "COLCAPIRHUA", "id": 2360 },
    { "cod": "CIU0335", "nombre": "COLCHAK", "id": 2365 },
    { "cod": "CIU0338", "nombre": "COLLANA", "id": 2362 },
    { "cod": "CIU0347", "nombre": "COLOMI", "id": 2360 },
    { "cod": "CIU0350", "nombre": "COLQUECHACA", "id": 2365 },
    { "cod": "CIU0351", "nombre": "COLQUENCHA", "id": 2362 },
    { "cod": "CIU0352", "nombre": "COLQUIRI", "id": 2362 },
    { "cod": "CIU0353", "nombre": "COMANCHE", "id": 2362 },
    { "cod": "CIU0354", "nombre": "COMARAPA", "id": 2366 },
    { "cod": "CIU0355", "nombre": "COMBAYA", "id": 2362 },
    { "cod": "CIU0358", "nombre": "CONCEPCION", "id": 2366 },
    { "cod": "CIU0370", "nombre": "COPACABANA", "id": 2362 },
    { "cod": "CIU0377", "nombre": "CORIPATA", "id": 2362 },
    { "cod": "CIU0380", "nombre": "CORO CORO", "id": 2362 },
    { "cod": "CIU0381", "nombre": "COROICO", "id": 2362 },
    { "cod": "CIU0383", "nombre": "CORQUE", "id": 2363 },
    { "cod": "CIU0389", "nombre": "COTAGAITA", "id": 2365 },
    { "cod": "CIU0392", "nombre": "COTOCA", "id": 2366 },
    { "cod": "CIU0398", "nombre": "CRUZ DE MACHACAMARCA", "id": 2363 },
    { "cod": "CIU0401", "nombre": "CUEVO", "id": 2366 },
    { "cod": "CIU0404", "nombre": "CULPINA", "id": 2367 },
    { "cod": "CIU0408", "nombre": "CURAHUARA DE CARANGAS", "id": 2363 },
    { "cod": "CIU0410", "nombre": "CURVA", "id": 2362 },
    { "cod": "CIU0413", "nombre": "DESAGUADERO", "id": 2362 },
    { "cod": "CIU0421", "nombre": "EL ALTO", "id": 2362 },
    { "cod": "CIU0427", "nombre": "CARMEN RIVERO TORREZ", "id": 2366 },
    { "cod": "CIU0428", "nombre": "EL CHORO", "id": 2363 },
    { "cod": "CIU0436", "nombre": "EL PUENTE", "id": 2368 },
    { "cod": "CIU0437", "nombre": "EL PUENTE", "id": 2366 },
    { "cod": "CIU0441", "nombre": "EL TORNO", "id": 2366 },
    { "cod": "CIU0443", "nombre": "EL VILLAR", "id": 2367 },
    { "cod": "CIU0447", "nombre": "ESCARA", "id": 2363 },
    { "cod": "CIU0449", "nombre": "ESCOMA", "id": 2362 },
    { "cod": "CIU0451", "nombre": "ESMERALDA", "id": 2363 },
    { "cod": "CIU0454", "nombre": "EUCALIPTUS", "id": 2363 },
    { "cod": "CIU0459", "nombre": "EXALTACION", "id": 2359 },
    { "cod": "CIU0485", "nombre": "GUANAY", "id": 2362 },
    { "cod": "CIU0486", "nombre": "GUAQUI", "id": 2362 },
    { "cod": "CIU0487", "nombre": "GUAYARAMERIN", "id": 2359 },
    { "cod": "CIU0488", "nombre": "GUTIERREZ", "id": 2366 },
    { "cod": "CIU0492", "nombre": "HUACARAJE", "id": 2359 },
    { "cod": "CIU0493", "nombre": "HUACAYA", "id": 2367 },
    { "cod": "CIU0494", "nombre": "HUACHACALLA", "id": 2363 },
    { "cod": "CIU0508", "nombre": "HUANUNI", "id": 2363 },
    { "cod": "CIU0511", "nombre": "HUARINA", "id": 2362 },
    { "cod": "CIU0518", "nombre": "HUATAJATA", "id": 2362 },
    { "cod": "CIU0525", "nombre": "HUAYLLAMARCA", "id": 2363 },
    { "cod": "CIU0535", "nombre": "ICHOCA", "id": 2362 },
    { "cod": "CIU0543", "nombre": "INCAHUASI", "id": 2367 },
    { "cod": "CIU0546", "nombre": "INDEPENDENCIA", "id": 2360 },
    { "cod": "CIU0547", "nombre": "INGAVI", "id": 2364 },
    { "cod": "CIU0550", "nombre": "INQUISIVI", "id": 2362 },
    { "cod": "CIU0557", "nombre": "IRUPANA", "id": 2362 },
    { "cod": "CIU0567", "nombre": "IXIAMAS", "id": 2362 },
    { "cod": "CIU0576", "nombre": "JESUS DE MACHACA", "id": 2362 },
    { "cod": "CIU0607", "nombre": "LA ASUNTA", "id": 2362 },
    { "cod": "CIU0616", "nombre": "LA GUARDIA", "id": 2366 },
    { "cod": "CIU0624", "nombre": "LA PAZ", "id": 2362 },
    { "cod": "CIU0626", "nombre": "LA RIVERA", "id": 2363 },
    { "cod": "CIU0637", "nombre": "LAGUNILLAS", "id": 2366 },
    { "cod": "CIU0639", "nombre": "LAJA", "id": 2362 },
    { "cod": "CIU0644", "nombre": "LAS CARRERAS", "id": 2367 },
    { "cod": "CIU0660", "nombre": "LLALLAGUA", "id": 2365 },
    { "cod": "CIU0664", "nombre": "LLICA", "id": 2365 },
    { "cod": "CIU0670", "nombre": "LORETO", "id": 2359 },
    { "cod": "CIU0673", "nombre": "LURIBAY", "id": 2362 },
    { "cod": "CIU0677", "nombre": "MACHACAMARCA", "id": 2363 },
    { "cod": "CIU0680", "nombre": "MACHARETI", "id": 2367 },
    { "cod": "CIU0681", "nombre": "MAGDALENA", "id": 2359 },
    { "cod": "CIU0682", "nombre": "MAIRANA", "id": 2366 },
    { "cod": "CIU0683", "nombre": "MALLA", "id": 2362 },
    { "cod": "CIU0689", "nombre": "MAPIRI", "id": 2362 },
    { "cod": "CIU0705", "nombre": "MECAPACA", "id": 2362 },
    { "cod": "CIU0716", "nombre": "MINEROS", "id": 2366 },
    { "cod": "CIU0717", "nombre": "MIZQUE", "id": 2360 },
    { "cod": "CIU0718", "nombre": "MOCOMOCO", "id": 2362 },
    { "cod": "CIU0719", "nombre": "MOJINETE", "id": 2365 },
    { "cod": "CIU0721", "nombre": "MOJOCOYA", "id": 2367 },
    { "cod": "CIU0728", "nombre": "MONTEAGUDO", "id": 2367 },
    { "cod": "CIU0729", "nombre": "MONTERO", "id": 2366 },
    { "cod": "CIU0732", "nombre": "MOROCHATA", "id": 2360 },
    { "cod": "CIU0757", "nombre": "OCURI", "id": 2365 },
    { "cod": "CIU0758", "nombre": "OKINAWA UNO", "id": 2366 },
    { "cod": "CIU0760", "nombre": "OMEREQUE", "id": 2360 },
    { "cod": "CIU0769", "nombre": "ORURO", "id": 2363 },
    { "cod": "CIU0778", "nombre": "PADCAYA", "id": 2368 },
    { "cod": "CIU0779", "nombre": "PADILLA", "id": 2367 },
    { "cod": "CIU0782", "nombre": "PAILON", "id": 2366 },
    { "cod": "CIU0788", "nombre": "PALCA", "id": 2362 },
    { "cod": "CIU0794", "nombre": "PALOS BLANCOS", "id": 2362 },
    { "cod": "CIU0796", "nombre": "PAMPA AULLAGAS", "id": 2363 },
    { "cod": "CIU0799", "nombre": "PAMPA GRANDE", "id": 2366 },
    { "cod": "CIU0804", "nombre": "PAPEL PAMPA", "id": 2362 },
    { "cod": "CIU0810", "nombre": "PASORAPA", "id": 2360 },
    { "cod": "CIU0812", "nombre": "PATACAMAYA", "id": 2362 },
    { "cod": "CIU0819", "nombre": "PAZÑA", "id": 2363 },
    { "cod": "CIU0825", "nombre": "PELECHUCO", "id": 2362 },
    { "cod": "CIU0844", "nombre": "POCOATA", "id": 2365 },
    { "cod": "CIU0846", "nombre": "POCONA", "id": 2360 },
    { "cod": "CIU0853", "nombre": "PORCO", "id": 2365 },
    { "cod": "CIU0854", "nombre": "POROMA", "id": 2367 },
    { "cod": "CIU0857", "nombre": "PORTACHUELO", "id": 2366 },
    { "cod": "CIU0860", "nombre": "POSTRERVALLE", "id": 2366 },
    { "cod": "CIU0863", "nombre": "POTOSI", "id": 2365 },
    { "cod": "CIU0865", "nombre": "PRESTO", "id": 2367 },
    { "cod": "CIU0869", "nombre": "PUCARANI", "id": 2362 },
    { "cod": "CIU0873", "nombre": "PUERTO ACOSTA", "id": 2362 },
    { "cod": "CIU0875", "nombre": "PUERTO CARABUCO", "id": 2362 },
    { "cod": "CIU0882", "nombre": "PUERTO QUIJARRO", "id": 2366 },
    { "cod": "CIU0884", "nombre": "PUERTO PEREZ", "id": 2362 },
    { "cod": "CIU0886", "nombre": "PUERTO SILES", "id": 2359 },
    { "cod": "CIU0887", "nombre": "PUERTO SUAREZ", "id": 2366 },
    { "cod": "CIU0888", "nombre": "PUERTO VILLARROEL", "id": 2360 },
    { "cod": "CIU0895", "nombre": "PUNA (VILLA TALAVERA)", "id": 2365 },
    { "cod": "CIU0897", "nombre": "PUNATA", "id": 2360 },
    { "cod": "CIU0905", "nombre": "QUIABAYA", "id": 2362 },
    { "cod": "CIU0908", "nombre": "QUILLACOLLO", "id": 2360 },
    { "cod": "CIU0910", "nombre": "QUIME", "id": 2362 },
    { "cod": "CIU0914", "nombre": "QUIRUSILLAS", "id": 2366 },
    { "cod": "CIU0918", "nombre": "RAVELO", "id": 2365 },
    { "cod": "CIU0921", "nombre": "REYES", "id": 2359 },
    { "cod": "CIU0922", "nombre": "RIBERALTA", "id": 2359 },
    { "cod": "CIU0930", "nombre": "ROBORE", "id": 2366 },
    { "cod": "CIU0947", "nombre": "RURRENABAQUE", "id": 2359 },
    { "cod": "CIU0949", "nombre": "SABAYA", "id": 2363 },
    { "cod": "CIU0950", "nombre": "SACABA", "id": 2360 },
    { "cod": "CIU0951", "nombre": "SACABAMBA", "id": 2360 },
    { "cod": "CIU0953", "nombre": "SACACA", "id": 2365 },
    { "cod": "CIU0956", "nombre": "SAIPINA", "id": 2366 },
    { "cod": "CIU0962", "nombre": "SALINAS DE GARCI MENDOZA", "id": 2363 },
    { "cod": "CIU0967", "nombre": "SAMAIPATA", "id": 2366 },
    { "cod": "CIU0970", "nombre": "SAN AGUSTIN", "id": 2365 },
    { "cod": "CIU0971", "nombre": "SAN ANDRES", "id": 2359 },
    { "cod": "CIU0972", "nombre": "SAN ANDRES DE MACHACA", "id": 2362 },
    { "cod": "CIU0974", "nombre": "SAN ANTONIO DE LOMERIO", "id": 2366 },
    { "cod": "CIU0981", "nombre": "SAN BORJA", "id": 2359 },
    { "cod": "CIU0982", "nombre": "SAN BUENAVENTURA", "id": 2362 },
    { "cod": "CIU0983", "nombre": "SAN CARLOS", "id": 2366 },
    { "cod": "CIU0994", "nombre": "SAN IGNACIO DE MOXOS", "id": 2359 },
    { "cod": "CIU0999", "nombre": "SAN JAVIER", "id": 2359 },
    { "cod": "CIU1000", "nombre": "SAN JAVIER", "id": 2366 },
    { "cod": "CIU1002", "nombre": "SAN JOAQUIN", "id": 2359 },
    { "cod": "CIU1007", "nombre": "SAN JOSE DE CHIQUITOS", "id": 2366 },
    { "cod": "CIU1024", "nombre": "SAN JULIAN", "id": 2366 },
    { "cod": "CIU1030", "nombre": "SAN LUCAS", "id": 2367 },
    { "cod": "CIU1038", "nombre": "SAN MATIAS", "id": 2366 },
    { "cod": "CIU1050", "nombre": "SAN PABLO DE LIPEZ", "id": 2365 },
    { "cod": "CIU1054", "nombre": "SAN PEDRO DE BUENA VISTA", "id": 2365 },
    { "cod": "CIU1057", "nombre": "SAN PEDRO", "id": 2366 },
    { "cod": "CIU1058", "nombre": "SAN PEDRO DE CURAHUARA", "id": 2362 },
    { "cod": "CIU1061", "nombre": "SAN PEDRO DE QUEMES", "id": 2365 },
    { "cod": "CIU1063", "nombre": "SAN PEDRO DE TIQUINA", "id": 2362 },
    { "cod": "CIU1064", "nombre": "SAN RAFAEL", "id": 2366 },
    { "cod": "CIU1065", "nombre": "SAN RAMON", "id": 2366 },
    { "cod": "CIU1066", "nombre": "SAN RAMON", "id": 2359 },
    { "cod": "CIU1075", "nombre": "SANTA ANA DEL YACUMA", "id": 2359 },
    { "cod": "CIU1078", "nombre": "SANTA CRUZ DE LA SIERRA", "id": 2366 },
    { "cod": "CIU1086", "nombre": "SANTA ROSA", "id": 2359 },
    { "cod": "CIU1108", "nombre": "SANTIAGO DE HUATA", "id": 2362 },
    { "cod": "CIU1110", "nombre": "SANTIAGO DE MACHACA", "id": 2362 },
    { "cod": "CIU1112", "nombre": "SANTIVAÑEZ", "id": 2360 },
    { "cod": "CIU1115", "nombre": "SANTUARIO DE QUILLACAS", "id": 2363 },
    { "cod": "CIU1130", "nombre": "SICA SICA", "id": 2362 },
    { "cod": "CIU1131", "nombre": "SICAYA", "id": 2360 },
    { "cod": "CIU1136", "nombre": "SIPE SIPE", "id": 2360 },
    { "cod": "CIU1149", "nombre": "SOPACHUY", "id": 2367 },
    { "cod": "CIU1150", "nombre": "SORACACHI", "id": 2363 },
    { "cod": "CIU1152", "nombre": "SORATA", "id": 2362 },
    { "cod": "CIU1160", "nombre": "SUCRE", "id": 2367 },
    { "cod": "CIU1168", "nombre": "TACACHI", "id": 2360 },
    { "cod": "CIU1169", "nombre": "TACACOMA", "id": 2362 },
    { "cod": "CIU1173", "nombre": "TACOBAMBA", "id": 2365 },
    { "cod": "CIU1175", "nombre": "TACOPAYA", "id": 2360 },
    { "cod": "CIU1178", "nombre": "TAHUA", "id": 2365 },
    { "cod": "CIU1184", "nombre": "TAPACARI", "id": 2360 },
    { "cod": "CIU1185", "nombre": "TARABUCO", "id": 2367 },
    { "cod": "CIU1186", "nombre": "TARACO", "id": 2362 },
    { "cod": "CIU1188", "nombre": "TARATA", "id": 2360 },
    { "cod": "CIU1191", "nombre": "TARIJA", "id": 2368 },
    { "cod": "CIU1194", "nombre": "TARVITA", "id": 2367 },
    { "cod": "CIU1201", "nombre": "TEOPONTE", "id": 2362 },
    { "cod": "CIU1205", "nombre": "TIAHUANACU", "id": 2362 },
    { "cod": "CIU1214", "nombre": "TINGUIPAYA", "id": 2365 },
    { "cod": "CIU1216", "nombre": "TIPUANI", "id": 2362 },
    { "cod": "CIU1217", "nombre": "TIQUIPAYA", "id": 2360 },
    { "cod": "CIU1218", "nombre": "TIRAQUE", "id": 2360 },
    { "cod": "CIU1220", "nombre": "TITO YUPANQUI", "id": 2362 },
    { "cod": "CIU1225", "nombre": "TODOS SANTOS", "id": 2363 },
    { "cod": "CIU1228", "nombre": "TOCO", "id": 2360 },
    { "cod": "CIU1229", "nombre": "TOLATA", "id": 2360 },
    { "cod": "CIU1230", "nombre": "TOLEDO", "id": 2363 },
    { "cod": "CIU1234", "nombre": "TOMAVE", "id": 2365 },
    { "cod": "CIU1236", "nombre": "TOMINA", "id": 2367 },
    { "cod": "CIU1241", "nombre": "TORO TORO", "id": 2365 },
    { "cod": "CIU1245", "nombre": "TOTORA", "id": 2360 },
    { "cod": "CIU1246", "nombre": "TOTORA", "id": 2363 },
    { "cod": "CIU1251", "nombre": "TRIGAL", "id": 2366 },
    { "cod": "CIU1253", "nombre": "TRINIDAD", "id": 2359 },
    { "cod": "CIU1264", "nombre": "TUPIZA", "id": 2365 },
    { "cod": "CIU1265", "nombre": "TURCO", "id": 2363 },
    { "cod": "CIU1273", "nombre": "UMALA", "id": 2362 },
    { "cod": "CIU1276", "nombre": "UNCIA", "id": 2365 },
    { "cod": "CIU1280", "nombre": "URMIRI", "id": 2365 },
    { "cod": "CIU1284", "nombre": "URUBICHA", "id": 2366 },
    { "cod": "CIU1288", "nombre": "UYUNI", "id": 2365 },
    { "cod": "CIU1293", "nombre": "VACAS", "id": 2360 },
    { "cod": "CIU1296", "nombre": "VALLEGRANDE", "id": 2366 },
    { "cod": "CIU1301", "nombre": "VIACHA", "id": 2362 },
    { "cod": "CIU1309", "nombre": "VILA VILA", "id": 2360 },
    { "cod": "CIU1314", "nombre": "VILLA ABECIA", "id": 2367 },
    { "cod": "CIU1345", "nombre": "VILLA NUEVA (LOMA ALTA)", "id": 2364 },
    { "cod": "CIU1355", "nombre": "VILLA RIVERO", "id": 2360 },
    { "cod": "CIU1363", "nombre": "VILLA TUNARI", "id": 2360 },
    { "cod": "CIU1367", "nombre": "VILLAMONTES", "id": 2368 },
    { "cod": "CIU1368", "nombre": "VILLAZON", "id": 2365 },
    { "cod": "CIU1372", "nombre": "VINTO", "id": 2360 },
    { "cod": "CIU1374", "nombre": "VITICHI", "id": 2365 },
    { "cod": "CIU1376", "nombre": "WALDO BALLIVIAN", "id": 2362 },
    { "cod": "CIU1378", "nombre": "WARNES", "id": 2366 },
    { "cod": "CIU1379", "nombre": "YACO", "id": 2362 },
    { "cod": "CIU1380", "nombre": "YACUIBA", "id": 2368 },
    { "cod": "CIU1385", "nombre": "YAMPARAEZ", "id": 2367 },
    { "cod": "CIU1386", "nombre": "YANACACHI", "id": 2362 },
    { "cod": "CIU1389", "nombre": "YAPACANI", "id": 2366 },
    { "cod": "CIU1394", "nombre": "YOCALLA", "id": 2365 },
    { "cod": "CIU1396", "nombre": "YOTALA", "id": 2367 },
    { "cod": "CIU1398", "nombre": "YUNCHARA", "id": 2368 },
    { "cod": "CIU1399", "nombre": "YUNGUYO DEL LITORAL", "id": 2363 },
    { "cod": "CIU1404", "nombre": "ZUDAÑEZ", "id": 2367 },
    { "cod": "CIU1405", "nombre": "NO APLICA", "id": 3468 },
    { "cod": "CIU1406", "nombre": "HUACARETA", "id": 2367 },
    { "cod": "CIU1407", "nombre": "ICLA", "id": 2367 },
    { "cod": "CIU1408", "nombre": "MUYUPAMPA", "id": 2367 },
    { "cod": "CIU1409", "nombre": "VILLA ALCALA", "id": 2367 },
    { "cod": "CIU1410", "nombre": "VILLA CHARCAS", "id": 2367 },
    { "cod": "CIU1411", "nombre": "VILLA SERRANO", "id": 2367 },
    { "cod": "CIU1412", "nombre": "CUCHUMUELA", "id": 2360 },
    { "cod": "CIU1413", "nombre": "ENTRE RIOS", "id": 2360 },
    { "cod": "CIU1414", "nombre": "SAN BENITO", "id": 2360 },
    { "cod": "CIU1415", "nombre": "SHINAHOTA", "id": 2360 },
    { "cod": "CIU1416", "nombre": "ALTO BENI", "id": 2362 },
    { "cod": "CIU1417", "nombre": "CALLAPA", "id": 2362 },
    { "cod": "CIU1418", "nombre": "HUMANATA", "id": 2362 },
    { "cod": "CIU1419", "nombre": "NAZACARA DE PACAJES", "id": 2362 },
    { "cod": "CIU1420", "nombre": "SAHAPAQUI", "id": 2362 },
    { "cod": "CIU1421", "nombre": "VILLA LIBERTAD DE LICOMA", "id": 2362 },
    { "cod": "CIU1422", "nombre": "HUARI", "id": 2363 },
    { "cod": "CIU1423", "nombre": "POOPO", "id": 2363 },
    { "cod": "CIU1424", "nombre": "SANTIAGO DE ANDAMARCA", "id": 2363 },
    { "cod": "CIU1425", "nombre": "BELLA FLOR", "id": 2364 },
    { "cod": "CIU1426", "nombre": "BOLPEBRA", "id": 2364 },
    { "cod": "CIU1427", "nombre": "FILADELFIA", "id": 2364 },
    { "cod": "CIU1428", "nombre": "NUEVA ESPERANZA", "id": 2364 },
    { "cod": "CIU1429", "nombre": "PORVENIR", "id": 2364 },
    { "cod": "CIU1430", "nombre": "PUERTO GONZALO MORENO", "id": 2364 },
    { "cod": "CIU1431", "nombre": "PUERTO RICO", "id": 2364 },
    { "cod": "CIU1432", "nombre": "SAN LORENZO", "id": 2364 },
    { "cod": "CIU1433", "nombre": "SAN PEDRO", "id": 2364 },
    { "cod": "CIU1434", "nombre": "SANTA ROSA DEL ABUNA", "id": 2364 },
    { "cod": "CIU1435", "nombre": "SANTOS MERCADO", "id": 2364 },
    { "cod": "CIU1436", "nombre": "SENA", "id": 2364 },
    { "cod": "CIU1437", "nombre": "QHOCHAS", "id": 2365 },
    { "cod": "CIU1453", "nombre": "ENTRE RIOS", "id": 2368 },
    { "cod": "CIU1438", "nombre": "URIONDO", "id": 2368 },
    { "cod": "CIU1439", "nombre": "VILLA SAN LORENZO", "id": 2368 },
    { "cod": "CIU1440", "nombre": "AGUSTIN SAAVEDRA", "id": 2366 },
    { "cod": "CIU1441", "nombre": "PORONGO (AYACUCHO)", "id": 2366 },
    { "cod": "CIU1442", "nombre": "COLPA BELGICA", "id": 2366 },
    { "cod": "CIU1443", "nombre": "CUATRO CAÑADAS", "id": 2366 },
    { "cod": "CIU1444", "nombre": "FERNANDEZ ALONSO", "id": 2366 },
    { "cod": "CIU1445", "nombre": "MORO MORO", "id": 2366 },
    { "cod": "CIU1446", "nombre": "PUCARA", "id": 2366 },
    { "cod": "CIU1447", "nombre": "SAN IGNACIO DE VELASCO", "id": 2366 },
    { "cod": "CIU1448", "nombre": "SAN JUAN DE YAPACANI", "id": 2366 },
    { "cod": "CIU1449", "nombre": "SAN MIGUEL DE VELASCO", "id": 2366 },
    { "cod": "CIU1450", "nombre": "SANTA ROSA DEL SARA", "id": 2366 },
    { "cod": "CIU1451", "nombre": "POJO", "id": 2360 },
    { "cod": "CIU1452", "nombre": "SAN ANTONIO DE ESMORUCO", "id": 2365 }
]

let collection_barrios = [
    { "cod": "BAR0001", "nombre": "14 DE SEPTIEMBRE", "id": 2362},
    { "cod": "BAR0002", "nombre": "1ERO DE MAYO", "id": 2362},
    { "cod": "BAR0003", "nombre": "24 SEPTIEMBRE-S.JOSE-EL CARMEN", "id": 2359},
    { "cod": "BAR0004", "nombre": "27 MAY-MARBAN-SCZ-BUSCH-S.JUAN", "id": 2359},
    { "cod": "BAR0005", "nombre": "27 MAYO-PEDRO-MARBAN-STA CRUZ", "id": 2359},
    { "cod": "BAR0006", "nombre": "4 JUL-LA LOMA-EL CARMEN-GUADAL", "id": 2368},
    { "cod": "BAR0007", "nombre": "6 AGOSTO-NUEVA MARCA-P.MURILLO", "id": 2362},
    { "cod": "BAR0009", "nombre": "ABUNA", "id": 2364},
    { "cod": "BAR0010", "nombre": "ACHACHICALA ALTO", "id": 2362},
    { "cod": "BAR0011", "nombre": "ACHACHICALA BAJO", "id": 2362},
    { "cod": "BAR0012", "nombre": "ACHUMANI", "id": 2362},
    { "cod": "BAR0013", "nombre": "ACHUMANI ALTO-UMAPALCA", "id": 2362},
    { "cod": "BAR0014", "nombre": "AEROPUERTO-SAN JERONIMO", "id": 2368},
    { "cod": "BAR0015", "nombre": "AGUA DE CASTILLA NORTE Y SUR", "id": 2363},
    { "cod": "BAR0016", "nombre": "ALALAY", "id": 2360},
    { "cod": "BAR0017", "nombre": "ALALAY-BARRIO MINERO", "id": 2360},
    { "cod": "BAR0018", "nombre": "ALALAY-VILLA PAGADOR", "id": 2360},
    { "cod": "BAR0021", "nombre": "ALTO ARANJUEZ", "id": 2360},
    { "cod": "BAR0022", "nombre": "ALTO CHIJINI", "id": 2362},
    { "cod": "BAR0023", "nombre": "ALTO LIMA - 2DA. SECCION", "id": 2362},
    { "cod": "BAR0024", "nombre": "ALTO LIMA - 3ER. SECCION", "id": 2362},
    { "cod": "BAR0025", "nombre": "ALTO LIMA 1 SEC.-SAID-VICTORIA", "id": 2362},
    { "cod": "BAR0026", "nombre": "ALTO LIMA 1ERA. SECCION", "id": 2362},
    { "cod": "BAR0027", "nombre": "ALTO OBRAJES", "id": 2362},
    { "cod": "BAR0028", "nombre": "ALTO OBRAJES-V.ARMONIA-ISIDRO", "id": 2362},
    { "cod": "BAR0033", "nombre": "ANTOFAGASTA-ILLIMANI-DOLORES F", "id": 2362},
    { "cod": "BAR0037", "nombre": "ARANJUEZ-MALLASA-MALLASILLA", "id": 2362},
    { "cod": "BAR0038", "nombre": "ARANJUEZ-MAX TOLEDO-SAN ROQUE", "id": 2367},
    { "cod": "BAR0047", "nombre": "B.OBRERO BAJO-S.PABLO-M.NEGRO", "id": 2367},
    { "cod": "BAR0048", "nombre": "B.PERIODISTA-POCONAS-SAN JOSE", "id": 2367},
    { "cod": "BAR0049", "nombre": "B.PETROLERO-B.BANCARIO-MADONA", "id": 2367},
    { "cod": "BAR0051", "nombre": "BARRIO FERROVARIO SUD", "id": 2360},
    { "cod": "BAR0052", "nombre": "BARRIO JUAN XXIII", "id": 2368},
    { "cod": "BAR0053", "nombre": "BARRIO MINERO", "id": 2363},
    { "cod": "BAR0054", "nombre": "BARRIO MINERO CENTRAL", "id": 2363},
    { "cod": "BAR0055", "nombre": "BARRIO MINERO NORTE", "id": 2363},
    { "cod": "BAR0056", "nombre": "BARRIO MINERO SUD", "id": 2363},
    { "cod": "BAR0057", "nombre": "BARRIO MUNICIPAL", "id": 2360},
    { "cod": "BAR0058", "nombre": "BARRIO PETROLERO", "id": 2362},
    { "cod": "BAR0061", "nombre": "BELEN", "id": 2362},
    { "cod": "BAR0064", "nombre": "BELLA VISTA", "id": 2362},
    { "cod": "BAR0065", "nombre": "BELLO HORIZONTE", "id": 2362},
    { "cod": "BAR0068", "nombre": "BOLIVAR MUNICIPAL-URB.VILLAZON", "id": 2362},
    { "cod": "BAR0070", "nombre": "BOLOGNIA", "id": 2362},
    { "cod": "BAR0071", "nombre": "BRACAMONTE-HUACHACALLA-CANTUMA", "id": 2365},
    { "cod": "BAR0076", "nombre": "BUSCH-INGAVI-MERCURIO-REMEDIOS", "id": 2362},
    { "cod": "BAR0077", "nombre": "BUSCH-J.PABLO-BLASS-MIRAFLORES", "id": 2368},
    { "cod": "BAR0078", "nombre": "CALACOTO", "id": 2362},
    { "cod": "BAR0079", "nombre": "CALACOTO-AUQUISAMAÑA", "id": 2362},
    { "cod": "BAR0080", "nombre": "CALACOTO-LA FLORIDA", "id": 2362},
    { "cod": "BAR0082", "nombre": "CALLAMPAYA", "id": 2362},
    { "cod": "BAR0083", "nombre": "CALLAPA-CIUDAD DEL NIÑO", "id": 2362},
    { "cod": "BAR0087", "nombre": "CARANAVI", "id": 2362},
    { "cod": "BAR0090", "nombre": "CENTRAL", "id": 2367},
    { "cod": "BAR0091", "nombre": "CENTRAL", "id": 2360},
    { "cod": "BAR0092", "nombre": "CENTRAL", "id": 2359},
    { "cod": "BAR0093", "nombre": "CENTRAL ESTE A Y B", "id": 2363},
    { "cod": "BAR0094", "nombre": "CENTRAL OESTE", "id": 2363},
    { "cod": "BAR0095", "nombre": "CENTRAL SUD", "id": 2360},
    { "cod": "BAR0096", "nombre": "CENTRAL-STA BARBARA", "id": 2362},
    { "cod": "BAR0097", "nombre": "CENTRO 12 DE OCTUBRE", "id": 2362},
    { "cod": "BAR0102", "nombre": "CHALLAPAMPA", "id": 2362},
    { "cod": "BAR0103", "nombre": "CHAMPA RANCHO-MAICA CHICA", "id": 2360},
    { "cod": "BAR0106", "nombre": "CHASQUIPAMPA-OVEJUYO-PEDREGAL", "id": 2362},
    { "cod": "BAR0110", "nombre": "CHIMBA CHICA", "id": 2360},
    { "cod": "BAR0111", "nombre": "CHIMBA GRANDE", "id": 2360},
    { "cod": "BAR0112", "nombre": "CHIQUICOLLO", "id": 2360},
    { "cod": "BAR0114", "nombre": "CHUQUIAGUILLO", "id": 2362},
    { "cod": "BAR0116", "nombre": "CIUDAD SATELITE", "id": 2365},
    { "cod": "BAR0117", "nombre": "CIUDAD SATELITE-ALPACOMA", "id": 2362},
    { "cod": "BAR0119", "nombre": "CONDEBAMBA", "id": 2360},
    { "cod": "BAR0125", "nombre": "COSMOS 77", "id": 2362},
    { "cod": "BAR0126", "nombre": "COSMOS 79-QUISWARAS-URB S.CRUZ", "id": 2362},
    { "cod": "BAR0128", "nombre": "COTA COTA-AUQUISAMAÑA", "id": 2362},
    { "cod": "BAR0129", "nombre": "COTACOQUENI-LOS SAUCES-OVEJUYO", "id": 2362},
    { "cod": "BAR0130", "nombre": "CRUZ VERDE-SANTA ANA-CENTRAL", "id": 2367},
    { "cod": "BAR0132", "nombre": "CUSICANCHA-MUNAYPATA", "id": 2362},
    { "cod": "BAR0136", "nombre": "EL MOLINO", "id": 2368},
    { "cod": "BAR0137", "nombre": "EL MORRO-LA MADONA", "id": 2367},
    { "cod": "BAR0139", "nombre": "EL ROSARIO", "id": 2362},
    { "cod": "BAR0141", "nombre": "EL TEJAR-ALTO TEJAR", "id": 2362},
    { "cod": "BAR0144", "nombre": "ESPAÑA ESTE", "id": 2363},
    { "cod": "BAR0145", "nombre": "ESPAÑA SUD A Y B", "id": 2363},
    { "cod": "BAR0149", "nombre": "FATIMA-TRINIDAD-25 DICIEMBRE", "id": 2359},
    { "cod": "BAR0154", "nombre": "G.BUSCH-LUIS DE FUENTES-SENAC", "id": 2368},
    { "cod": "BAR0157", "nombre": "GERMAN BUSCH-VINO TINTO", "id": 2362},
    { "cod": "BAR0159", "nombre": "GRAL. FEDERICO ROMAN", "id": 2364},
    { "cod": "BAR0161", "nombre": "GRAN PODER-CHIJINI", "id": 2362},
    { "cod": "BAR0167", "nombre": "HIPODROMO", "id": 2360},
    { "cod": "BAR0170", "nombre": "HORIZ.3-PORVENIR-ASUNCI.-PEDRO", "id": 2362},
    { "cod": "BAR0172", "nombre": "HUAJCHILLA-RIO ABAJO", "id": 2362},
    { "cod": "BAR0173", "nombre": "HUAYRA KHASA-EL TICTI", "id": 2360},
    { "cod": "BAR0174", "nombre": "HUAYRAPATA-ARENAL-OLMOS-TEJAR", "id": 2367},
    { "cod": "BAR0178", "nombre": "INDUSTRIAL", "id": 2359},
    { "cod": "BAR0183", "nombre": "IRPAVI-BARRIO DEL PERIODISTA", "id": 2362},
    { "cod": "BAR0187", "nombre": "JAIHUAYCO", "id": 2360},
    { "cod": "BAR0191", "nombre": "JATUN PAMPA", "id": 2360},
    { "cod": "BAR0200", "nombre": "KANTUTANI", "id": 2362},
    { "cod": "BAR0201", "nombre": "KOANI - ALTO IRPAVI", "id": 2362},
    { "cod": "BAR0202", "nombre": "LA MERCED-EL CARMEN", "id": 2362},
    { "cod": "BAR0203", "nombre": "LA PORTADA", "id": 2362},
    { "cod": "BAR0204", "nombre": "LA TABLADITA-ALTO SENAC", "id": 2368},
    { "cod": "BAR0205", "nombre": "LA ZARZUELA", "id": 2362},
    { "cod": "BAR0208", "nombre": "LAS CUADRAS", "id": 2360},
    { "cod": "BAR0209", "nombre": "LAS DELICIAS", "id": 2362},
    { "cod": "BAR0210", "nombre": "LAS DELICIAS-BAR.UNIVERSITARIO", "id": 2367},
    { "cod": "BAR0211", "nombre": "LAS DELICIAS-CEMENTERIO", "id": 2365},
    { "cod": "BAR0214", "nombre": "LLOJETA-ALPACOMA", "id": 2362},
    { "cod": "BAR0215", "nombre": "LOMAS DE ARANJUEZ", "id": 2360},
    { "cod": "BAR0216", "nombre": "LORETO-AEROPTO-BOLIVAR-MISERIA", "id": 2362},
    { "cod": "BAR0218", "nombre": "LOS CHAPACOS", "id": 2368},
    { "cod": "BAR0219", "nombre": "LOS OLIVOS-COTA COTA ALTO", "id": 2362},
    { "cod": "BAR0220", "nombre": "LOS PINOS", "id": 2362},
    { "cod": "BAR0221", "nombre": "LOYOLA B.-M.VERDE-SAN JUANILLO", "id": 2367},
    { "cod": "BAR0223", "nombre": "LUIS DE FUENTES-LA FLORESTA", "id": 2368},
    { "cod": "BAR0224", "nombre": "LUIS ESPINAL - VILLA ALEMANIA", "id": 2362},
    { "cod": "BAR0226", "nombre": "M.VERDE-JUANILLO-LIBERTADORES", "id": 2367},
    { "cod": "BAR0227", "nombre": "MADRE DE DIOS", "id": 2364},
    { "cod": "BAR0228", "nombre": "MAGISTERIO-CUPILUPACA-DELICIAS", "id": 2362},
    { "cod": "BAR0232", "nombre": "MANGALITO-SCZ SUR-27 MAY-MARBA", "id": 2359},
    { "cod": "BAR0234", "nombre": "MANURIPI", "id": 2364},
    { "cod": "BAR0237", "nombre": "MAYORAZGO-CALA CALA NOROESTE", "id": 2360},
    { "cod": "BAR0240", "nombre": "MEJILLON.-INGENIO-TAHUANTINSU.", "id": 2362},
    { "cod": "BAR0241", "nombre": "MENDEZ ARCOS-SAN ANTONIO", "id": 2368},
    { "cod": "BAR0243", "nombre": "MESADILLA-BARRIO PETROLERO", "id": 2360},
    { "cod": "BAR0246", "nombre": "MIRAFLORES ALTO", "id": 2362},
    { "cod": "BAR0247", "nombre": "MIRAFLORES NORTE", "id": 2362},
    { "cod": "BAR0248", "nombre": "MIRAFLORES SUD", "id": 2362},
    { "cod": "BAR0253", "nombre": "MUNAYPATA", "id": 2362},
    { "cod": "BAR0254", "nombre": "MUYURINA", "id": 2360},
    { "cod": "BAR0258", "nombre": "NICOLAS SUAREZ", "id": 2364},
    { "cod": "BAR0262", "nombre": "NOR ESTE", "id": 2363},
    { "cod": "BAR0263", "nombre": "NOR ESTE A Y B", "id": 2363},
    { "cod": "BAR0265", "nombre": "NOR OESTE", "id": 2363},
    { "cod": "BAR0266", "nombre": "NOR OESTE A", "id": 2363},
    { "cod": "BAR0267", "nombre": "NOR OESTE B", "id": 2363},
    { "cod": "BAR0269", "nombre": "NOROESTE CENTRAL", "id": 2360},
    { "cod": "BAR0270", "nombre": "NORTE", "id": 2363},
    { "cod": "BAR0271", "nombre": "NORTE", "id": 2362},
    { "cod": "BAR0272", "nombre": "NORTE CENTRAL", "id": 2363},
    { "cod": "BAR0273", "nombre": "NUEVO HORIZONTE I-21 DICIEMBRE", "id": 2362},
    { "cod": "BAR0275", "nombre": "OBISPO INDABURO", "id": 2362},
    { "cod": "BAR0277", "nombre": "OBRAJES", "id": 2362},
    { "cod": "BAR0278", "nombre": "OESTE VINTO", "id": 2363},
    { "cod": "BAR0279", "nombre": "OESTE VINTO A", "id": 2363},
    { "cod": "BAR0280", "nombre": "OESTE VINTO B", "id": 2363},
    { "cod": "BAR0281", "nombre": "OESTE VINTO C", "id": 2363},
    { "cod": "BAR0282", "nombre": "OESTE VINTO D", "id": 2363},
    { "cod": "BAR0285", "nombre": "ORURO CENTRAL", "id": 2363},
    { "cod": "BAR0286", "nombre": "ORURO ESTE", "id": 2363},
    { "cod": "BAR0287", "nombre": "ORURO NORTE", "id": 2363},
    { "cod": "BAR0288", "nombre": "ORURO SUR", "id": 2363},
    { "cod": "BAR0291", "nombre": "PAMPAHASI ALTO", "id": 2362},
    { "cod": "BAR0292", "nombre": "PANAMA", "id": null},
    { "cod": "BAR0295", "nombre": "PARAISO-SAN NICOLAS", "id": 2362},
    { "cod": "BAR0296", "nombre": "PARQUE BOLIVAR-QUIRPINCHACA", "id": 2367},
    { "cod": "BAR0300", "nombre": "POMPEYA", "id": 2359},
    { "cod": "BAR0302", "nombre": "PORTALES", "id": 2360},
    { "cod": "BAR0305", "nombre": "PROLONGACION HIPODROMO", "id": 2360},
    { "cod": "BAR0309", "nombre": "PURA PURA", "id": 2362},
    { "cod": "BAR0310", "nombre": "PURA PURA ALTO", "id": 2362},
    { "cod": "BAR0311", "nombre": "QUERU QUERU", "id": 2360},
    { "cod": "BAR0322", "nombre": "ROMERO PAMPA-SAN LUIS C. PAMPA", "id": 2362},
    { "cod": "BAR0324", "nombre": "ROSAS PAMPA-VILLA PUCARANI", "id": 2362},
    { "cod": "BAR0325", "nombre": "ROSEDAL-15 ABRIL-L.ESPINAL", "id": 2368},
    { "cod": "BAR0326", "nombre": "S.ANTONIO-B.JAPON-SAGR.CORAZON", "id": 2367},
    { "cod": "BAR0327", "nombre": "S.ANTONIO-S.VICENTE-AEROPUERTO", "id": 2359},
    { "cod": "BAR0328", "nombre": "S.CRISTOBAL-PTA.DIESEL-S.ROQUE", "id": 2367},
    { "cod": "BAR0329", "nombre": "S.FRANCISCO-RECOLETA-V.CHARCAS", "id": 2367},
    { "cod": "BAR0330", "nombre": "S.JOSE YUNGUYO-25 JULIO-16 FEB", "id": 2362},
    { "cod": "BAR0331", "nombre": "S.JUAN DE DIOS-QUIRPINCHACA", "id": 2367},
    { "cod": "BAR0332", "nombre": "S.ROQUE-LA PAMPA-OSCAR ALFARO", "id": 2368},
    { "cod": "BAR0333", "nombre": "SAGDO. CORAZON-CHAMOCO-MURILLO", "id": 2362},
    { "cod": "BAR0337", "nombre": "SAN BENITO", "id": 2365},
    { "cod": "BAR0338", "nombre": "SAN BERNARDO-NARCISO CAMPERO", "id": 2368},
    { "cod": "BAR0339", "nombre": "SAN CRISTOBAL", "id": 2365},
    { "cod": "BAR0340", "nombre": "SAN JOSE-MERCADO-VILLA ABAROA", "id": 2368},
    { "cod": "BAR0341", "nombre": "SAN LUIS-SAN JORGE", "id": 2368},
    { "cod": "BAR0342", "nombre": "SAN MARTIN,SAN JUAN-CONCEPCION", "id": 2365},
    { "cod": "BAR0343", "nombre": "SAN MIGUEL", "id": 2362},
    { "cod": "BAR0344", "nombre": "SAN MIGUEL-CERRO VERDE", "id": 2360},
    { "cod": "BAR0346", "nombre": "SAN PEDRO", "id": 2365},
    { "cod": "BAR0347", "nombre": "SAN PEDRO ALTO", "id": 2362},
    { "cod": "BAR0348", "nombre": "SAN PEDRO BAJO", "id": 2362},
    { "cod": "BAR0350", "nombre": "SAN ROQUE", "id": 2365},
    { "cod": "BAR0351", "nombre": "SAN SEBASTIAN", "id": 2362},
    { "cod": "BAR0352", "nombre": "SAN SIMON-PACASA-UNION S.JOSE", "id": 2362},
    { "cod": "BAR0353", "nombre": "SANTA ANA DE CALA CALA", "id": 2360},
    { "cod": "BAR0354", "nombre": "SANTA BARBARA NORTE", "id": 2360},
    { "cod": "BAR0355", "nombre": "SANTA BARBARA SUD", "id": 2360},
    { "cod": "BAR0356", "nombre": "SANTA ROSA GRANDE-27 DE MAYO", "id": 2362},
    { "cod": "BAR0358", "nombre": "SARCO", "id": 2360},
    { "cod": "BAR0361", "nombre": "SEGUENCOMA ALTO Y BAJO", "id": 2362},
    { "cod": "BAR0362", "nombre": "SENKATA-KENKO-R.PAMPA-COMBIFAC", "id": 2362},
    { "cod": "BAR0364", "nombre": "SOPOCACHI ALTO", "id": 2362},
    { "cod": "BAR0365", "nombre": "SOPOCACHI BAJO", "id": 2362},
    { "cod": "BAR0366", "nombre": "STA ROSA-SAN JUAN-AGUA DE VIDA", "id": 2362},
    { "cod": "BAR0367", "nombre": "SUCRE-COOP-INGEN.-TAHUANTINSU.", "id": 2362},
    { "cod": "BAR0368", "nombre": "SUD", "id": 2363},
    { "cod": "BAR0370", "nombre": "SUD CENTRAL A Y B", "id": 2363},
    { "cod": "BAR0373", "nombre": "SUD ESTE A, B Y C", "id": 2363},
    { "cod": "BAR0374", "nombre": "SUD KASAPATA-VILLA CORONILLA", "id": 2360},
    { "cod": "BAR0376", "nombre": "SUD OESTE", "id": 2360},
    { "cod": "BAR0377", "nombre": "SUD OESTE A", "id": 2363},
    { "cod": "BAR0378", "nombre": "SUD OESTE B", "id": 2363},
    { "cod": "BAR0379", "nombre": "SUD OESTE C", "id": 2363},
    { "cod": "BAR0380", "nombre": "SUD OESTE D", "id": 2363},
    { "cod": "BAR0382", "nombre": "TACAGUA", "id": 2362},
    { "cod": "BAR0384", "nombre": "TAMAYO-23 MARZO-ESTRELLA BELEN", "id": 2362},
    { "cod": "BAR0386", "nombre": "TAQUIÑA", "id": 2360},
    { "cod": "BAR0387", "nombre": "TEMBLADERANI", "id": 2362},
    { "cod": "BAR0388", "nombre": "TEMBLADERANI-LOMAS PASANKERI", "id": 2362},
    { "cod": "BAR0389", "nombre": "TEMPORAL", "id": 2360},
    { "cod": "BAR0391", "nombre": "THIKA LOMA", "id": 2365},
    { "cod": "BAR0397", "nombre": "TUCSUPAYA-QUIRPINCHACA-ARMONIA", "id": 2367},
    { "cod": "BAR0398", "nombre": "TUPURAYA", "id": 2360},
    { "cod": "BAR0399", "nombre": "U.V.1-MAQUINA VIEJA", "id": 2366},
    { "cod": "BAR0400", "nombre": "U.V.10-LA RAMADA", "id": 2366},
    { "cod": "BAR0401", "nombre": "U.V.100-AV.VIRGEN DE COTOCA", "id": 2366},
    { "cod": "BAR0402", "nombre": "U.V.101-23 DE MARZO-SAN MARTIN", "id": 2366},
    { "cod": "BAR0403", "nombre": "U.V.102-MAURO BERTERO", "id": 2366},
    { "cod": "BAR0404", "nombre": "U.V.103-21 DE SEPTIEMBRE", "id": 2366},
    { "cod": "BAR0405", "nombre": "U.V.104-25 DE DIC.-PAILITA", "id": 2366},
    { "cod": "BAR0406", "nombre": "U.V.105", "id": 2366},
    { "cod": "BAR0407", "nombre": "U.V.106-LA COLORADA", "id": 2366},
    { "cod": "BAR0408", "nombre": "U.V.107-SIMON BOLIVAR", "id": 2366},
    { "cod": "BAR0409", "nombre": "U.V.108-V.COPACABANA-CUCHILLA", "id": 2366},
    { "cod": "BAR0410", "nombre": "U.V.109-SANTA CRUZ", "id": 2366},
    { "cod": "BAR0411", "nombre": "U.V.11-FE Y ALEGRIA", "id": 2366},
    { "cod": "BAR0412", "nombre": "U.V.110-KNISE", "id": 2366},
    { "cod": "BAR0413", "nombre": "U.V.111-BARRIO CAÑOTO", "id": 2366},
    { "cod": "BAR0414", "nombre": "U.V.112-LAS CARMELITAS", "id": 2366},
    { "cod": "BAR0415", "nombre": "U.V.113-CURUPAU", "id": 2366},
    { "cod": "BAR0416", "nombre": "U.V.114-COLORADA 11-SENAC-26/4", "id": 2366},
    { "cod": "BAR0417", "nombre": "U.V.115-B.OLIVO-TRANSPORTISTAS", "id": 2366},
    { "cod": "BAR0418", "nombre": "U.V.116-MORA GRANDE-MISIONES", "id": 2366},
    { "cod": "BAR0419", "nombre": "U.V.117-D.BOSCO-INDEPENDENCIA", "id": 2366},
    { "cod": "BAR0420", "nombre": "U.V.118-V.ORTUÑO-V.ANTOFAGASTA", "id": 2366},
    { "cod": "BAR0421", "nombre": "U.V.119-BARRIO CALIFORNIA", "id": 2366},
    { "cod": "BAR0422", "nombre": "U.V.12-PALERMO-BANCARIO", "id": 2366},
    { "cod": "BAR0423", "nombre": "U.V.120-JENECHERU-LA LOMA", "id": 2366},
    { "cod": "BAR0424", "nombre": "U.V.121-JARDIN BOTANICO", "id": 2366},
    { "cod": "BAR0425", "nombre": "U.V.122-SECTOR SAO SALUD", "id": 2366},
    { "cod": "BAR0426", "nombre": "U.V.123-SECTOR SAO SALUD", "id": 2366},
    { "cod": "BAR0427", "nombre": "U.V.125-VILLA CALAMA", "id": 2366},
    { "cod": "BAR0428", "nombre": "U.V.126-EL BAJIO-BETHESDA", "id": 2366},
    { "cod": "BAR0429", "nombre": "U.V.127-FABRILES", "id": 2366},
    { "cod": "BAR0430", "nombre": "U.V.128-LAS MALVINAS", "id": 2366},
    { "cod": "BAR0431", "nombre": "U.V.129-AVENIDAS A Y 1", "id": 2366},
    { "cod": "BAR0432", "nombre": "U.V.13-BARTOS", "id": 2366},
    { "cod": "BAR0433", "nombre": "U.V.130", "id": 2366},
    { "cod": "BAR0434", "nombre": "U.V.131-LAS AMERICAS", "id": 2366},
    { "cod": "BAR0435", "nombre": "U.V.132-26 DE SEPTIEMBRE", "id": 2366},
    { "cod": "BAR0436", "nombre": "U.V.133-LAS AMERICAS", "id": 2366},
    { "cod": "BAR0437", "nombre": "U.V.134-AVENIDAS 1 Y A", "id": 2366},
    { "cod": "BAR0438", "nombre": "U.V.135-TIERRAS NUEVAS", "id": 2366},
    { "cod": "BAR0439", "nombre": "U.V.136-CAMPO ROSA", "id": 2366},
    { "cod": "BAR0440", "nombre": "U.V.137-SANTA CRUZ", "id": 2366},
    { "cod": "BAR0441", "nombre": "U.V.138-TELCHI", "id": 2366},
    { "cod": "BAR0442", "nombre": "U.V.139", "id": 2366},
    { "cod": "BAR0443", "nombre": "U.V.14-BARTOS", "id": 2366},
    { "cod": "BAR0444", "nombre": "U.V.140-GUARACACHI", "id": 2366},
    { "cod": "BAR0445", "nombre": "U.V.141-V.VENEZUELA-S.ANTONIO", "id": 2366},
    { "cod": "BAR0446", "nombre": "U.V.142-LOS MINEROS", "id": 2366},
    { "cod": "BAR0447", "nombre": "U.V.143-VILLA GLADYS", "id": 2366},
    { "cod": "BAR0448", "nombre": "U.V.144-FABRIL-ASINALCLASS", "id": 2366},
    { "cod": "BAR0449", "nombre": "U.V.145-AVENIDA F-CALLE A", "id": 2366},
    { "cod": "BAR0450", "nombre": "U.V.146-BOLIVIA", "id": 2366},
    { "cod": "BAR0451", "nombre": "U.V.147-PLAN 3000", "id": 2366},
    { "cod": "BAR0452", "nombre": "U.V.148-MUNICIPAL", "id": 2366},
    { "cod": "BAR0453", "nombre": "U.V.149-BARRIO BOLIVAR", "id": 2366},
    { "cod": "BAR0454", "nombre": "U.V.15-STA CLARA-LA STA CRUZ", "id": 2366},
    { "cod": "BAR0455", "nombre": "U.V.150-VILLA UNION", "id": 2366},
    { "cod": "BAR0456", "nombre": "U.V.151-VIRGEN DE LUJAN", "id": 2366},
    { "cod": "BAR0457", "nombre": "U.V.152-LA ESPERANZA", "id": 2366},
    { "cod": "BAR0458", "nombre": "U.V.153-LA PASCANA-ESPAÑA", "id": 2366},
    { "cod": "BAR0459", "nombre": "U.V.154-SAN JUAN DE DIOS", "id": 2366},
    { "cod": "BAR0460", "nombre": "U.V.16-PETROLERO NORTE-MAESTRO", "id": 2366},
    { "cod": "BAR0461", "nombre": "U.V.17-LOS ANGELES-TUSEQUIS", "id": 2366},
    { "cod": "BAR0462", "nombre": "U.V.18-LOS ANGELES-TUSEQUIS", "id": 2366},
    { "cod": "BAR0463", "nombre": "U.V.19-G.VILLAROEL-R.BRAUN", "id": 2366},
    { "cod": "BAR0464", "nombre": "U.V.2-EL PARAISO", "id": 2366},
    { "cod": "BAR0465", "nombre": "U.V.20-LA CHACARILLA", "id": 2366},
    { "cod": "BAR0466", "nombre": "U.V.21-LAZARETO", "id": 2366},
    { "cod": "BAR0467", "nombre": "U.V.22-AV.BRASIL-RADIAL 8", "id": 2366},
    { "cod": "BAR0468", "nombre": "U.V.23-COTECAR", "id": 2366},
    { "cod": "BAR0469", "nombre": "U.V.24-PETROLERO SUR", "id": 2366},
    { "cod": "BAR0470", "nombre": "U.V.25-EL TROMPILLO", "id": 2366},
    { "cod": "BAR0471", "nombre": "U.V.26-AEROPUERTO-AERONAUTICO", "id": 2366},
    { "cod": "BAR0472", "nombre": "U.V.27-RAMAFA-BRANNIF-STA ROSA", "id": 2366},
    { "cod": "BAR0473", "nombre": "U.V.28-EL PARY", "id": 2366},
    { "cod": "BAR0474", "nombre": "U.V.29-URBARI-COOPER", "id": 2366},
    { "cod": "BAR0475", "nombre": "U.V.3-OBRERO", "id": 2366},
    { "cod": "BAR0476", "nombre": "U.V.30-SANTA ROSITA", "id": 2366},
    { "cod": "BAR0477", "nombre": "U.V.31-V.PALERMO,S.LUIS,4 NOV.", "id": 2366},
    { "cod": "BAR0478", "nombre": "U.V.32-CERVECERIA SANTA CRUZ", "id": 2366},
    { "cod": "BAR0479", "nombre": "U.V.33-FAREMAFU", "id": 2366},
    { "cod": "BAR0480", "nombre": "U.V.34-EQUIPETROL", "id": 2366},
    { "cod": "BAR0481", "nombre": "U.V.35-ABAROA-LA SALLE", "id": 2366},
    { "cod": "BAR0482", "nombre": "U.V.36-MARABOC-MACDONALD", "id": 2366},
    { "cod": "BAR0483", "nombre": "U.V.37-HAMACAS", "id": 2366},
    { "cod": "BAR0484", "nombre": "U.V.38-BANCARIOS", "id": 2366},
    { "cod": "BAR0485", "nombre": "U.V.39-VILLA PILLIN", "id": 2366},
    { "cod": "BAR0486", "nombre": "U.V.4-CALLE BALLIVIAN,R.CHAVEZ", "id": 2366},
    { "cod": "BAR0487", "nombre": "U.V.40-MAGISTERIO-DESTROYERS", "id": 2366},
    { "cod": "BAR0488", "nombre": "U.V.41-CONAVI", "id": 2366},
    { "cod": "BAR0489", "nombre": "U.V.42-COOPERATIVA LA BELGICA", "id": 2366},
    { "cod": "BAR0490", "nombre": "U.V.43-BARRIO SANANDITA", "id": 2366},
    { "cod": "BAR0491", "nombre": "U.V.44-ESTACION ARGENTINA", "id": 2366},
    { "cod": "BAR0492", "nombre": "U.V.45-POLANCO-LAS PALMERAS", "id": 2366},
    { "cod": "BAR0493", "nombre": "U.V.46-EL PAJONAL-HAWAI", "id": 2366},
    { "cod": "BAR0494", "nombre": "U.V.47-EL GUARACAL", "id": 2366},
    { "cod": "BAR0495", "nombre": "U.V.48-LA MORITA", "id": 2366},
    { "cod": "BAR0496", "nombre": "U.V.49-LA MORITA", "id": 2366},
    { "cod": "BAR0497", "nombre": "U.V.5-BARRIO LINDO", "id": 2366},
    { "cod": "BAR0498", "nombre": "U.V.50-ALTO S.PEDRO-V. WARNES", "id": 2366},
    { "cod": "BAR0499", "nombre": "U.V.51-CLUB HIPICO-NUEVA RIOJA", "id": 2366},
    { "cod": "BAR0500", "nombre": "U.V.52-LAS PALMAS-MACPETROL", "id": 2366},
    { "cod": "BAR0501", "nombre": "U.V.53-BARRIO UNIVERSITARIO", "id": 2366},
    { "cod": "BAR0502", "nombre": "U.V.54-VILLA MERCEDES", "id": 2366},
    { "cod": "BAR0503", "nombre": "U.V.55-VILLA 4 DE NOVIEMBRE", "id": 2366},
    { "cod": "BAR0504", "nombre": "U.V.56-EL CARMEN", "id": 2366},
    { "cod": "BAR0505", "nombre": "U.V.57-VILLA BUSCH, QUEMADA", "id": 2366},
    { "cod": "BAR0506", "nombre": "U.V.58-SIRARI-GUAPAY", "id": 2366},
    { "cod": "BAR0507", "nombre": "U.V.59-VILLA BRIGIDA", "id": 2366},
    { "cod": "BAR0508", "nombre": "U.V.6-BARRIO CHOFERES", "id": 2366},
    { "cod": "BAR0509", "nombre": "U.V.60-AV. LA SALLE-RADIAL 26", "id": 2366},
    { "cod": "BAR0510", "nombre": "U.V.61-RADIAL 26-AV. J.COIMBRA", "id": 2366},
    { "cod": "BAR0511", "nombre": "U.V.62-AV. COIMBRA-AV. BANZER", "id": 2366},
    { "cod": "BAR0512", "nombre": "U.V.63-VILLA COTOCA-V. NORTE", "id": 2366},
    { "cod": "BAR0513", "nombre": "U.V.64-SAGUAPAC-VILLA JARDIN", "id": 2366},
    { "cod": "BAR0514", "nombre": "U.V.65-CONFIVAG-LA MERCED", "id": 2366},
    { "cod": "BAR0515", "nombre": "U.V.66-LOS MANGALES-COTAS", "id": 2366},
    { "cod": "BAR0516", "nombre": "U.V.67-SAN JORGE-CORDECRUZ", "id": 2366},
    { "cod": "BAR0517", "nombre": "U.V.68-FERBO-VELARDE-9DE ABRIL", "id": 2366},
    { "cod": "BAR0518", "nombre": "U.V.69-VILLA LUZ-HAMACAS", "id": 2366},
    { "cod": "BAR0519", "nombre": "U.V.7-1ER ANILLO-C.MANZO,GARZA", "id": 2366},
    { "cod": "BAR0520", "nombre": "U.V.70-LOS TOTAISES", "id": 2366},
    { "cod": "BAR0521", "nombre": "U.V.71-LOS TUSEQUIS", "id": 2366},
    { "cod": "BAR0522", "nombre": "U.V.72-SANTA ISABEL", "id": 2366},
    { "cod": "BAR0523", "nombre": "U.V.73-SAN JORGE-LA FLORIDA", "id": 2366},
    { "cod": "BAR0524", "nombre": "U.V.74-METALMEC", "id": 2366},
    { "cod": "BAR0525", "nombre": "U.V.75-15 DE DICIEMBRE", "id": 2366},
    { "cod": "BAR0526", "nombre": "U.V.76-EL CARMEN", "id": 2366},
    { "cod": "BAR0527", "nombre": "U.V.77-ENTEL-NUEVA JERUSALEM", "id": 2366},
    { "cod": "BAR0528", "nombre": "U.V.78-UNIVERSITARIO", "id": 2366},
    { "cod": "BAR0529", "nombre": "U.V.79-SAN MARTIN-BARRIO COTAS", "id": 2366},
    { "cod": "BAR0530", "nombre": "U.V.8-EST. TAHUICHI-B. MILITAR", "id": 2366},
    { "cod": "BAR0531", "nombre": "U.V.81-METROPOLITANO", "id": 2366},
    { "cod": "BAR0532", "nombre": "U.V.82-SAN JUAN", "id": 2366},
    { "cod": "BAR0533", "nombre": "U.V.83-EL PORVENIR", "id": 2366},
    { "cod": "BAR0534", "nombre": "U.V.84-LOS ANDES-18 DE MARZO", "id": 2366},
    { "cod": "BAR0535", "nombre": "U.V.85-VILLA LUCERO", "id": 2366},
    { "cod": "BAR0536", "nombre": "U.V.86-VILLA 1ERO DE MAYO", "id": 2366},
    { "cod": "BAR0537", "nombre": "U.V.87-BOLIVAR", "id": 2366},
    { "cod": "BAR0538", "nombre": "U.V.88-PLANTA DE ALTA TENSION", "id": 2366},
    { "cod": "BAR0539", "nombre": "U.V.89-VILLA SUCRE", "id": 2366},
    { "cod": "BAR0540", "nombre": "U.V.9-EL PARY", "id": 2366},
    { "cod": "BAR0541", "nombre": "U.V.90-CONVIPET-CONVIFAG", "id": 2366},
    { "cod": "BAR0542", "nombre": "U.V.90-LIBERTAD", "id": 2366},
    { "cod": "BAR0543", "nombre": "U.V.91-HEROES DEL CHACO-PENOCO", "id": 2366},
    { "cod": "BAR0544", "nombre": "U.V.92-CAÑADA EL CARMEN", "id": 2366},
    { "cod": "BAR0545", "nombre": "U.V.93-LUIS SORUCO BARBA", "id": 2366},
    { "cod": "BAR0546", "nombre": "U.V.94-TRES LAGUNAS", "id": 2366},
    { "cod": "BAR0547", "nombre": "U.V.95-CONSTRUCTORES", "id": 2366},
    { "cod": "BAR0548", "nombre": "U.V.97-26 DE ABRIL", "id": 2366},
    { "cod": "BAR0549", "nombre": "U.V.98-LUIS SANDOVAL MORON", "id": 2366},
    { "cod": "BAR0550", "nombre": "U.V.99-LUIS SANDOVAL MORON", "id": 2366},
    { "cod": "BAR0551", "nombre": "U.V.A-HOSPITAL-C.N.S.S.", "id": 2366},
    { "cod": "BAR0552", "nombre": "U.V.B-EL ARENAL-LOS POZOS", "id": 2366},
    { "cod": "BAR0553", "nombre": "U.V.C-CALLE WARNES,CBB,LPZ,POI", "id": 2366},
    { "cod": "BAR0554", "nombre": "U.V.D-CALLE COLON,PARI,INGAVI", "id": 2366},
    { "cod": "BAR0555", "nombre": "U.V.IL-AV.ORTIZ,BRASIL-RADIAL8", "id": 2366},
    { "cod": "BAR0556", "nombre": "U.V.PI-AV.MUTUALISTA", "id": 2366},
    { "cod": "BAR0557", "nombre": "U.V.PS5-AV.JUSTINIANO-4 ANILLO", "id": 2366},
    { "cod": "BAR0558", "nombre": "URB.CIPRIANO-BARACE-V.VECI", "id": 2359},
    { "cod": "BAR0559", "nombre": "URBANIZACION IRLANDESA", "id": 2360},
    { "cod": "BAR0561", "nombre": "UV41A-PARQUE INDUSTRIAL -SCZ", "id": 2366},
    { "cod": "BAR0562", "nombre": "V.ADELA-YUNGUYO-2 DE FEBRERO", "id": 2362},
    { "cod": "BAR0563", "nombre": "V.BOLIVAR A", "id": 2362},
    { "cod": "BAR0564", "nombre": "V.BOLIVAR C Y D-S.PEDRO-AVAROA", "id": 2362},
    { "cod": "BAR0565", "nombre": "V.COPACABANA,ARMONIA,VENEZUELA", "id": 2365},
    { "cod": "BAR0566", "nombre": "V.COPACABANA-ROSAL-HUAYCHANI", "id": 2362},
    { "cod": "BAR0567", "nombre": "V.HERMOSO-FERROVARIO-SURAPATA", "id": 2367},
    { "cod": "BAR0568", "nombre": "V.HUAYNA POTOSI-ANEXO H.POTOSI", "id": 2362},
    { "cod": "BAR0569", "nombre": "V.INGENIO 1ER.SEC-V.STRONGEST", "id": 2362},
    { "cod": "BAR0570", "nombre": "V.INGENIO 2DA.SEC-V.SAN JUAN", "id": 2362},
    { "cod": "BAR0571", "nombre": "V.MARGARITA-B.LINDO-A.DELICIAS", "id": 2367},
    { "cod": "BAR0572", "nombre": "V.PACAJES-V.SAN LUIS TASA", "id": 2362},
    { "cod": "BAR0575", "nombre": "VALLE HERMOSO", "id": 2360},
    { "cod": "BAR0579", "nombre": "VILLA 16 DE JULIO", "id": 2362},
    { "cod": "BAR0580", "nombre": "VILLA ADELA - AMIGO CHACO", "id": 2362},
    { "cod": "BAR0581", "nombre": "VILLA ARMONIA", "id": 2360},
    { "cod": "BAR0582", "nombre": "VILLA BALLIVIAN OESTE", "id": 2362},
    { "cod": "BAR0583", "nombre": "VILLA BUSCH SUD", "id": 2360},
    { "cod": "BAR0584", "nombre": "VILLA COPACABANA-VALLE HERMOSO", "id": 2362},
    { "cod": "BAR0585", "nombre": "VILLA CORONILLA SUD", "id": 2360},
    { "cod": "BAR0586", "nombre": "VILLA DE LA CRUZ", "id": 2362},
    { "cod": "BAR0587", "nombre": "VILLA DOLORES", "id": 2362},
    { "cod": "BAR0588", "nombre": "VILLA ESPERANZA", "id": 2363},
    { "cod": "BAR0589", "nombre": "VILLA ESPERANZA CENTRAL", "id": 2363},
    { "cod": "BAR0590", "nombre": "VILLA ESPERANZA OESTE", "id": 2363},
    { "cod": "BAR0591", "nombre": "VILLA ESPERANZA SUD", "id": 2363},
    { "cod": "BAR0592", "nombre": "VILLA EXALTACION-SANTA ROSA", "id": 2362},
    { "cod": "BAR0593", "nombre": "VILLA FATIMA", "id": 2362},
    { "cod": "BAR0594", "nombre": "VILLA GRACIELA", "id": 2360},
    { "cod": "BAR0595", "nombre": "VILLA JULIANA-VILLA PRIMAVERA", "id": 2362},
    { "cod": "BAR0596", "nombre": "VILLA KENNEDY", "id": 2360},
    { "cod": "BAR0597", "nombre": "VILLA LOS ANDES", "id": 2362},
    { "cod": "BAR0598", "nombre": "VILLA MCAL SANTA CRUZ", "id": 2362},
    { "cod": "BAR0599", "nombre": "VILLA MCAL SANTA CRUZ ALTO", "id": 2362},
    { "cod": "BAR0600", "nombre": "VILLA MEXICO", "id": 2360},
    { "cod": "BAR0601", "nombre": "VILLA NUEVO POTOSI", "id": 2362},
    { "cod": "BAR0602", "nombre": "VILLA PABON", "id": 2362},
    { "cod": "BAR0603", "nombre": "VILLA SAN ANTONIO", "id": 2362},
    { "cod": "BAR0604", "nombre": "VILLA SANTIAGO I", "id": 2362},
    { "cod": "BAR0605", "nombre": "VILLA SANTIAGO II-V.BOLIVAR E", "id": 2362},
    { "cod": "BAR0606", "nombre": "VILLA SANTIAGO-VILLA ESPAÑA", "id": 2365},
    { "cod": "BAR0607", "nombre": "VILLA TEJADA", "id": 2362},
    { "cod": "BAR0608", "nombre": "VILLA TUNARI", "id": 2362},
    { "cod": "BAR0609", "nombre": "VILLA TUPAC KATARI-V.ESPERANZA", "id": 2362},
    { "cod": "BAR0610", "nombre": "VILLA VICTORIA", "id": 2362},
    { "cod": "BAR0611", "nombre": "VIVIENDAS RIO SECO", "id": 2362},
    { "cod": "BAR0612", "nombre": "W.ALBA-B.FERROVIARIO-EL PAMPON", "id": 2365},
    { "cod": "BAR0617", "nombre": "YUNGUYO-SUCRE-ORIENTAL-BRASIL", "id": 2362},
    { "cod": "BAR0619", "nombre": "ZONA CENTRAL", "id": 2365},
    { "cod": "BAR0620", "nombre": "ZONA CENTRAL", "id": 2368},
    { "cod": "BAR0621", "nombre": "ZONA CENTRAL-LAS PANOSAS", "id": 2368},
    { "cod": "BAR0624", "nombre": "NO APLICA", "id": 3468},
    { "cod": "BAR0625", "nombre": "ANDRES IBAÑEZ", "id": 2366},
    { "cod": "BAR0626", "nombre": "IGNACIO WARNES", "id": 2366},
    { "cod": "BAR0627", "nombre": "JOSE MIGUEL DE VELASCO", "id": 2366},
    { "cod": "BAR0628", "nombre": "ICHILO", "id": 2366},
    { "cod": "BAR0629", "nombre": "CHIQUITOS", "id": 2366},
    { "cod": "BAR0630", "nombre": "CORDILLERA DE LOS CHIRIGUANOS", "id": 2366},
    { "cod": "BAR0631", "nombre": "VALLEGRANDE", "id": 2366},
    { "cod": "BAR0632", "nombre": "FLORIDA", "id": 2366},
    { "cod": "BAR0633", "nombre": "OBISPO J. BELISARIO SANTISTEBAN", "id": 2366},
    { "cod": "BAR0634", "nombre": "ÑUFLO DE CHAVEZ", "id": 2366},
    { "cod": "BAR0635", "nombre": "ANGEL SANDOVAL", "id": 2366},
    { "cod": "BAR0636", "nombre": "MANUEL M.CABALLERO", "id": 2366},
    { "cod": "BAR0637", "nombre": "GERMAN BUSCH", "id": 2366},
    { "cod": "BAR0638", "nombre": "GUARAYOS", "id": 2366},
    { "cod": "BAR0639", "nombre": "SARA", "id": 2366}
]